var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.userId)?_c('v-flex',{attrs:{"xs12":""}},[_c('add-user-favorite',{attrs:{"type":"favorite_search","favorite":_vm.selectedFavorite,"userId":_vm.userId},on:{"AssetSelected":_vm.selected}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }